function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { ConnectionHandler, getRelayHandleKey } from 'relay-runtime';
import { getStableStorageKey } from 'relay-runtime/lib/store/RelayStoreUtils';
var CONNECTION_HANDLE_KEYS = '__connectionHandleKeys';

function update(store, payload) {
  var _extends2;

  ConnectionHandler.update(store, payload); // Hackishly get the handle key minus the args.

  var _payload$handleKey$sp = payload.handleKey.split('('),
      handleName = _payload$handleKey$sp[0];

  var record = store.get(payload.dataID);
  var prevHandleKeys = record.getValue(CONNECTION_HANDLE_KEYS, {
    handleName: handleName
  });

  var nextHandleKeys = _extends({}, prevHandleKeys, (_extends2 = {}, _extends2[payload.handleKey] = payload.args, _extends2)); // FIXME: The RecordProxy API doesn't let us set objects as values. We bypass
  //  this validation by reaching into internals.
  // eslint-disable-next-line no-underscore-dangle


  var mutator = record._mutator; // It's slightly janky to store this as a value rather than as linked
  //  records, but this will prevent the value from getting GCed so long as the
  //  parent record stays live, which is what we want. These data are light
  //  enough that this shouldn't take too much memory.

  mutator.setValue(record.getDataID(), getStableStorageKey(CONNECTION_HANDLE_KEYS, {
    handleName: handleName
  }), nextHandleKeys);
}

function connectionExists(connection) {
  return !!connection;
}

function getConnections(record, key, filter) {
  var handleName = getRelayHandleKey('connection', key, null);
  var handleKeys = record.getValue(CONNECTION_HANDLE_KEYS, {
    handleName: handleName
  });

  if (!handleKeys) {
    return [];
  }

  return Object.entries(handleKeys).filter(function (_ref) {
    var _handleKey = _ref[0],
        args = _ref[1];
    return !filter || filter(args);
  }).map(function (_ref2) {
    var handleKey = _ref2[0];
    return (// XXX: This takes advantage of how a full storageKey with args can be
      //  used in place of name and args separately.
      record.getLinkedRecord(handleKey)
    );
  }).filter(connectionExists);
}

export default _extends({}, ConnectionHandler, {
  update: update,
  getConnections: getConnections
});